"use client"

import { useState } from "react"
import Image from "next/image"
import { Store } from "lucide-react"

export default function BrandLogo({
  image,
  name,
  featured = false,
}: {
  image: string | null
  name: string
  featured?: boolean
}) {
  const [failedImage, setFailedImage] = useState<string | null>(null)
  const size = featured ? 170 : 64

  if (!image || image === failedImage) {
    return (
      <span
        className="flex shrink-0 items-center justify-center rounded-[6px] text-[#86909C]"
        style={{ width: size, height: size }}
      >
        <Store aria-hidden="true" size={featured ? 56 : 32} strokeWidth={1.5} />
      </span>
    )
  }

  return (
    <Image
      src={image}
      alt={`${name} logo`}
      width={size}
      height={size}
      sizes={`${size}px`}
      loading={featured ? "eager" : "lazy"}
      onError={() => setFailedImage(image)}
      className="max-h-full max-w-full shrink-0 rounded-[6px] object-contain"
      style={{ width: size, height: size }}
    />
  )
}
